<template>
    <service-screen-layout :parts="parts">
        <template v-slot:usage>
            <IonlineDataUsage />
        </template>
    </service-screen-layout>
</template>

<script>
import ServiceScreenLayout from '@/layouts/ServiceScreenLayout.vue';
import IonlineDataUsage from '@/components/ObjParts/MultipleLoaded/IonlineDataUsage.vue';

    export default {
        components: {
            ServiceScreenLayout,
            IonlineDataUsage
        },
        data() {
            return {
                parts: [
                    {
                        name: "usage",
                        icon: "fa fa-chart-simple",
                        displayName: "Usage Data",
                        permissions: ["*"],
                    },
                ],
                saleNumber: null,
                saleDefinition: {
                    definition: {
                        usage: {
                            apnApnBulkUsage: []
                        }
                    }
                }
            }
        },
        mounted() {
            this.saleNumber = this.$root.$route.params.saleNumber;
            this.getSaleDefinition();
        },
        methods: {
            getSaleDefinition: function() {
                const hostUrl = this.$config.aimsAPI;

                this.$http.get(`${hostUrl}sales/definition/sale/${this.saleNumber}`).then(
                    (response) => {                    
                        this.saleDefinition = response.data;
                    },
                    (error) => {
                        console.error(error);
                        this.showError("Error fetching Sale Definition", error);
                    }
                )
            }
        }
    }
</script>`